export const newsPaths = {
  news: "/news",
};
